<template>
  <template v-if="!Player">
    <div class="video-lazy-wrapper ratio ratio-16x9">
      <div class="video-wrapper" :class="{ initialized: false }">
        <video
          :id="`video-container-${id}`"
          class="video-js no-preview"
          preload="none"
          :poster="poster"
          crossorigin="anonymous"
          playsinline
          :muted="true"
        />
      </div>
    </div>
  </template>
  <template v-else>
    <div :class="shown ? '' : 'ratio ratio-16x9'">
      <component
        :is="Player"
        :id="id"
        ratio="16x9"
        :source="video?.hls_url || source"
        :poster="poster"
        :subtitles-en="video?.subtitles_en || undefined"
        :subtitles-de="video?.subtitles_de || undefined"
        :subtitles-fr="video?.subtitles_fr || undefined"
        :cast="false"
        @show="onShow"
      />
    </div>
  </template>
</template>

<script setup lang="ts">
import { defineAsyncComponent, PropType, ref } from "vue";
import { FreeareaVideo } from "@/interfaces/Video/FreeareaVideo.ts";
import { isPerformanceCheck } from "@/utils/domHelper.ts";

defineOptions({
  name: "lazy-player",
});

defineProps({
  video: {
    type: Object as PropType<FreeareaVideo>,
    required: false,
    default: null,
  },
  source: {
    type: String,
    default: "",
    required: false,
  },
  id: {
    type: String,
    required: true,
  },
  poster: {
    type: String,
    required: true,
  },
});
const Player = isPerformanceCheck ? null : defineAsyncComponent(() => import("@/components/player/index.vue"));
const shown = ref(false);

const onShow = () => {
  shown.value = true;
};
</script>

<style lang="scss">
@import "../player/index";
</style>
